// extracted by mini-css-extract-plugin
export var lg = "_2g-4";
export var md = "_2g-3";
export var sm = "_2g-2";
export var xs = "_2g-1";
export var xxs = "_2g-0";